import { render, staticRenderFns } from "./ValidationWidget.vue?vue&type=template&id=ebcd7e48&"
import script from "./ValidationWidget.vue?vue&type=script&lang=ts&"
export * from "./ValidationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports